import React from "react";
import ReactTooltip from "react-tooltip";
import Logger from "../../util/Logger";
import "./Switch.scss";

export const Switch = ({
  id,
  checked,
  text,
  disabled,
  disabledTooltip,
  onChange,
  className,
}) => {
  if (!id) {
    Logger.assert("Cannot create Switch without id");
  }

  if (checked === null || checked === undefined) {
    Logger.assert("Cannot create Switch without checked attribute");
  }

  if (text === null || text === undefined) {
    Logger.assert("Cannot create Switch without text attribute");
  }

  if (!onChange) {
    Logger.assert("Cannot create Switch without onChange callback");
  }

  const tooltipId = `Switch-tooltip-${id}`;

  /**
   * Don't access switch globals in here unless you like memory leaks.
   *
   * @param onChange
   * @param $event
   */
  const handleSwitchChanged = (onChange, $event) => {
    const checkbox = $event.target;
    if (checkbox) {
      onChange(!!checkbox.checked);
    }
  };

  const handleClick = (onChange, checked, $event) => {
    $event.preventDefault();

    onChange(!checked);
  };

  return (
    <div
      className={`custom-control custom-switch d-inline-block my-auto ${className} ${disabled ? "disabled" : "clickable"}`}
    >
      <span
        data-tip
        data-for={disabled ? tooltipId : ""}
      >
        <input
          className="custom-control-input"
          id={id}
          type="checkbox"
          disabled={disabled}
          checked={checked}
          onChange={($event) => handleSwitchChanged(onChange, $event)}
        />
        <span
          className="custom-control-track font-size-md"
          onClick={($event) => handleClick(onChange, checked, $event)}
        />
        <label
          className="custom-control-label font-size-md"
          htmlFor={id}
        >
          {text}
        </label>
      </span>
      <ReactTooltip id={tooltipId} disable={!disabled}>
        {disabledTooltip}
      </ReactTooltip>
    </div>
  );
};
